
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-04151ff0&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Participant.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Participant.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-04151ff0!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Participant.vue"),
  /* scopeId */
  "data-v-04151ff0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/Participants/Participant.vue
// module id = 1812
// module chunks = 61